import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { THEME_VARS } from "./store/themeStore";

// Apply theme CSS variables before first render to avoid flash
const stored = localStorage.getItem("theme");
const initial = stored ? (JSON.parse(stored)?.state?.theme ?? "light") : "light";
const vars = THEME_VARS[initial as "light" | "dark"];
Object.entries(vars).forEach(([k, v]) => document.documentElement.style.setProperty(k, v));

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
